import React, { FunctionComponent } from "react"

interface LoungeIconProps {
  fillColor?: string
  strokeColor?: string
}

export const LoungeIcon: FunctionComponent<LoungeIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="1" width="20" height="8" rx="4" fill="white" />
      <rect x="13" y="12" width="9" height="9" rx="3.5" fill="white" />
      <path
        d="M3 13L5.91632 20.0477L6.95168 16.9786L10 15.9362L3 13Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const WYRIcon: FunctionComponent<LoungeIconProps> = ({
  strokeColor = "6633FF",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10.5" y="1" width="3" height="22" rx="1.5" fill="white" />
      <circle cx="5.44922" cy="7.45001" r="3.75" fill="white" />
      <circle cx="18.5508" cy="16.55" r="3.75" fill="white" />
      <circle cx="12" cy="12" r="4.5" fill="white" stroke={strokeColor} />
    </svg>
  )
}

export const TriviaIcon: FunctionComponent<LoungeIconProps> = ({
  strokeColor = "6633FF",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2.25" y="18.75" width="9" height="3" rx="1.5" fill="white" />
      <rect x="12.75" y="18.75" width="9" height="3" rx="1.5" fill="white" />
      <rect x="2.25" y="14.25" width="9" height="3" rx="1.5" fill="white" />
      <rect x="12.75" y="14.25" width="9" height="3" rx="1.5" fill="white" />
      <circle cx="5.25" cy="8.25" r="3.75" fill="white" />
      <circle cx="18.75" cy="8.25" r="3.75" fill="white" />
      <circle cx="12" cy="6" r="4.25" fill="white" stroke={strokeColor} />
    </svg>
  )
}

export const DoddleIcon: FunctionComponent<LoungeIconProps> = ({
  fillColor = "white",
  strokeColor = "#6633FF",
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.78056 17.2691C4.97704 17.0675 4.16222 17.5555 3.9606 18.359C3.75899 19.1625 4.24693 19.9773 5.05044 20.1789L5.78056 17.2691ZM21.9408 13.9329C22.3033 13.188 21.9932 12.2903 21.2483 11.9278C20.5033 11.5654 19.6056 11.8755 19.2432 12.6204L21.9408 13.9329ZM5.05044 20.1789C7.48019 20.7886 10.7344 21.0989 13.8645 20.34C17.0432 19.5693 20.1173 17.6807 21.9408 13.9329L19.2432 12.6204C17.8815 15.419 15.6364 16.8234 13.1576 17.4245C10.6301 18.0373 7.8887 17.7981 5.78056 17.2691L5.05044 20.1789Z"
      fill={fillColor}
    />
    <circle cx="6.25" cy="7.25" r="3.75" fill={fillColor} />
    <circle cx="17.75" cy="7.25" r="3.75" fill={fillColor} />
    <circle cx="12" cy="7" r="4.25" fill={fillColor} stroke={strokeColor} />
  </svg>
)

export const TtalIcon: FunctionComponent<LoungeIconProps> = ({
  strokeColor = "#6633FF",
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="3" width="6" height="4" rx="2" fill="white" />
    <rect x="9" y="3" width="6" height="4" rx="2" fill="white" />
    <rect x="16" y="3" width="6" height="4" rx="2" fill="white" />
    <circle cx="5" cy="17.5" r="3" fill="white" />
    <circle cx="19" cy="17.5" r="3" fill="white" />
    <circle cx="12" cy="16" r="5.5" fill="white" stroke={strokeColor} />
  </svg>
)

export const CharadesWhiteIcon: FunctionComponent<LoungeIconProps> = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10.8"
      y="1.19995"
      width="2.4"
      height="21.6"
      rx="1.2"
      fill="white"
    />
    <rect
      x="6.5"
      y="6.5"
      width="11"
      height="11"
      rx="4.5"
      fill="white"
      stroke="#F0F4F7"
    />
    <circle cx="5.5" cy="5.5" r="2.5" fill="white" />
    <circle cx="5.5" cy="18.5" r="2.5" fill="white" />
    <circle cx="2.5" cy="12.5" r="2.5" fill="white" />
    <circle r="2.5" transform="matrix(-1 0 0 1 18.5 5.5)" fill="white" />
    <circle r="2.5" transform="matrix(-1 0 0 1 18.5 18.5)" fill="white" />
    <circle r="2.5" transform="matrix(-1 0 0 1 21.5 12.5)" fill="white" />
  </svg>
)
